module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_6_4.aed5988e.jpeg";